import React, { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Tabs from '../../../features/components/Tabs'
import FacebookAudienceTable from './FacebookAudienceTable'
import TikTokAudienceTable from './TikTokAudienceTable'
import Dv360AudienceTable from './Dv360AudienceTable'

import { insertIf } from '../../../helpers/common'

import { selectedPartnershipSelector } from '../../../modules/selectors/partnerships'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../constants/selectLists/platformList'

import useCommonStyles from '../../../styles/common/listPage'
import useStyles from './styles'

const Audiences = () => {
  const commonClasses = useCommonStyles()
  const classes = useStyles()

  const { t } = useTranslation()

  const [selectedOption, setSelectedOption] = useState(FACEBOOK_PLATFORM)

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const facebookAdAccountId = selectedPartnership?.facebook_ad_account?.id
  const tikTokAdAccountId = selectedPartnership?.tiktok_ad_account?.id
  // const googleAdAccountId = selectedPartnership?.google_ad_account?.id
  const dv360AdAccountId = selectedPartnership?.dv360_ad_account?.id

  const options = useMemo(() => {
    return [
      ...insertIf(facebookAdAccountId, { label: 'Facebook', value: FACEBOOK_PLATFORM }),
      ...insertIf(tikTokAdAccountId, { label: 'TikTok', value: TIKTOK_PLATFORM }),
      // todo implement google ads audience table when BE fix /google/audiences/ endpoint
      // ...insertIf(googleAdAccountId, { label: 'Google Ads', value: GOOGLE_PLATFORM }),
      ...insertIf(dv360AdAccountId, { label: 'DV360', value: DV_360_PLATFORM })
    ]
  }, [
    facebookAdAccountId,
    tikTokAdAccountId,
    // googleAdAccountId,
    dv360AdAccountId
  ])

  const selectTabHandler = useCallback(
    value => {
      setSelectedOption(value)
    },
    [setSelectedOption]
  )

  const renderAudienceTable = useCallback(() => {
    switch (selectedOption) {
      case FACEBOOK_PLATFORM:
        return <FacebookAudienceTable />
      case TIKTOK_PLATFORM:
        return <TikTokAudienceTable />
      case GOOGLE_PLATFORM:
        // todo implement google ads audience table when BE fix /google/audiences/ endpoint
        return <div>Google Ads Audience Table (to be implemented)</div>
      case DV_360_PLATFORM:
        return <Dv360AudienceTable />
      default:
        return null
    }
  }, [selectedOption])

  return (
    <>
      <h2 className={commonClasses.title}>{t('Audiences')}</h2>
      <div className={classes.tabsWrapper}>
        <Tabs options={options} selectedValue={selectedOption} onSelectValue={selectTabHandler} />
      </div>

      {renderAudienceTable()}
    </>
  )
}

export default Audiences
